/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { BaseHttpRequest } from '../core/BaseHttpRequest';
import type { CancelablePromise } from '../core/CancelablePromise';
import type { DeleteSubjectsResponseDto } from '../models/DeleteSubjectsResponseDto';

export class SubjectsService {
  constructor(public readonly httpRequest: BaseHttpRequest) {}
  /**
   * Delete Subject
   * Delete all of a subject's discovery data across every set —
   * rows belonging to the subject and rows targeting it via a
   * dependent `target_ref`.
   *
   * The count includes rows that referenced a removed row (priority
   * rows).
   *
   * Idempotent — a subject with no stored data returns `deleted=0`
   * (never 404).
   * @param employeeId Owner identity
   * @param subjectId Narrow to one subject (a dependent). Omit to clear the whole employee — their own data and every dependent's, across all sets.
   * @returns DeleteSubjectsResponseDto Successful Response
   * @throws ApiError
   */
  public deleteSubjectDiscoveryV1SubjectsDelete(
    employeeId: string,
    subjectId?: string | null
  ): CancelablePromise<DeleteSubjectsResponseDto> {
    return this.httpRequest.request({
      method: 'DELETE',
      url: '/discovery/v1/subjects',
      query: {
        employee_id: employeeId,
        subject_id: subjectId,
      },
      errors: {
        422: `Validation Error`,
      },
    });
  }
}
